import axios from 'axios';
import Cookies from 'js-cookie';
// import { devMevAuth } from '../../constants';

const basePath =
    process.env.NODE_ENV === 'development'
        ? 'https://ekassa.id.md/data'
        : '/data';

axios.defaults.withCredentials = true;
const access_id = Cookies.get('access-id');
if (access_id) {
    axios.defaults.headers.common['access-id'] = access_id;
}
if (process.env.NODE_ENV === 'development') {
    axios.defaults.headers.common['auth'] = Cookies.get('simpalsid.auth');
}

// POST request to GraphQL create new z report
export function createNewReport(cashId, type) {
    return axios({
        url: basePath,
        method: 'post',
        data: {
            query: `
         mutation{
            generateReport(cashRegisterId:${cashId}  type:${type}){
              errors {
                message
              }
            }
          }`,
        },
    })
        .then(res => {
            return res;
        })
        .catch(err => {
            return err.message;
        });
}

// POST request to GraphQL get current user
export function getTaxesRates() {
    const taxes = axios({
        url: basePath,
        method: 'post',
        data: {
            query: `
          query {
            getTaxes{
              percent
              code
              rate
              title
              value
            }
          }
        `,
        },
    })
        .then(res => {
            return res.data;
        })
        .catch(err => {
            return err.message;
        });
    return taxes;
}

// POST request to GraphQL get current organization
export function getCurrentOrganization() {
    const organization = axios({
        url: basePath,
        method: 'post',
        data: {
            query: `
         query {
            getCurrentInfo{
              organization{
                name, 
                idno,
                cashRegisters{
                  id, 
                  model,
                  address,factory,number,key,
                  taxes {
                    id
                    code
                    title
                    percent
                    rate
                    enabled
                  }
                }
              }
              accesses {
                id
                organizationId
                organization{
                  name
                  id
                }
                role
              }
              account{
                userId,
                userId,
                login
              }
              user{
                id
                simpalsLogin
                simpalsId
                organizationId
                name
                currentAccess{
                  id
                  organizationId
                  organization{
                    name
                    id
                  }
                  role
                }
                accesses {
                  id
                  organizationId
                  role
                }
                cashRegisters{
                  cashRegisterId
                  apiKey
                  cashRegister {
                    id
                    model
                    address
                    factory
                    number
                    taxes {
                      id
                      code
                      title
                      percent
                      rate
                      enabled
                    }
                  }
                }
              }
            }         
        }`,
        },
    })
        .then(res => {
            return res.data;
        })
        .catch(err => {
            return err.message;
        });
    return organization;
}

// POST request to GraphQL get current user
export function getCurrentUser() {
    const organization = axios({
        url: basePath,
        method: 'post',
        data: {
            query: `
       query {
        getCurrentInfo{
          account{
            userId,login
          }
          user {
            id
            cashRegisters {
              cashRegisterId
              apiKey
              cashRegister {
                id
                model
                factory
                address
                number
                taxes {
                  id
                  title
                  percent
                  code
                  rate
                  enabled
                }
              }
            }
          }
        }
      }`,
        },
    })
        .then(res => {
            return res.data;
        })
        .catch(err => {
            return err.message;
        });
    return organization;
}

// POST request to GraphQL get all reports
export function getAllMyReports(
    { dateFrom, dateTo },
    limit,
    start,
    cashier_id,
    cashier_name,
    report_type,
    cash_register,
) {
    const reportVars = {
        sort: {
            column: '_id',
            direction: 'DESC',
        },
        ...(dateFrom && { dateFrom }),
        ...(dateTo && { dateTo }),
    };

    const { sort, dateFrom: fromDate, dateTo: toDate } = reportVars;

    const organization = axios({
        url: basePath,
        method: 'post',
        data: {
            query: `
         query{
          getReports(
            sort: {
              column: "${sort.column}", 
              direction: ${sort.direction} 
            }
             ${fromDate ? `, dateFrom: "${fromDate}"` : ''}
             ${toDate ? `, dateTo: "${toDate}"` : ''}
             ${limit ? `, limit: ${limit}` : ''}
             ${cashier_id ? `, cashierId: ${cashier_id}` : ''}
             ${cashier_name ? `, cashierName: "${cashier_name}"` : ''}
             ${report_type ? `, type: ${report_type}` : ''}
             ${cash_register ? `, cashRegisterId: ${cash_register},` : ''}
             start: ${start},
            )
            {
            count,
            data{
              id,
              cashier {
                id,
                name,
              },
              soapData{
                id, type, report, datetime,
                daily{total}
                year{total}
              },
              status,
            },
          }
        }`,
        },
    })
        .then(res => {
            return res.data;
        })
        .catch(err => {
            return err.message;
        });
    return organization;
}

// POST request to GraphQL get all receipts
export function getAllMyReceipts(
    { dateFrom, dateTo },
    limit,
    start,
    cashRegisterId,
    status,
    paymentType,
    cashierId,
    cashierName,
) {
    const receiptsVars = {
        sort: {
            column: '_id',
            direction: 'DESC',
        },
        ...(dateFrom && { dateFrom }),
        ...(dateTo && { dateTo }),
    };

    const { sort, dateFrom: fromDate, dateTo: toDate } = receiptsVars;

    const organization = axios({
        url: basePath,
        method: 'post',
        data: {
            query: `
       query{
        getFiscalReceipts(
            sort: {
              column: "${sort.column}", 
              direction: ${sort.direction} 
            }
            ${fromDate ? `, dateFrom: "${fromDate}"` : ''}
            ${toDate ? `, dateTo: "${toDate}"` : ''},
            ${limit ? `limit: ${limit}` : ``},
            ${cashRegisterId ? `cashRegisterId: ${cashRegisterId}` : ``},
            ${status ? `status: ${status}` : ``},
            ${paymentType ? `paymentType: ${paymentType}` : ``},
            ${cashierId ? `cashierId: ${cashierId}` : ``},
            ${cashierName ? `cashierName: "${cashierName}"` : ``},
            start: ${start},
        ){
          count,
          data{
            id,
            cashier {
              id,
              name,
            },
            soapData{
              id,receipt,report, datetime, data{total, payments{field{type}}}
            },
            status,
            cashRegisterId
          }
        }
      }`,
        },
    })
        .then(res => {
            return res.data;
        })
        .catch(err => {
            return err.message;
        });
    return organization;
}

// POST request to GraphQL  Get Receipt by id
export function getReceiptById(id) {
    const organization = axios({
        url: basePath,
        method: 'post',
        data: {
            query: `
       query {
        getFiscalReceipt(id: ${id}){
        id,status,mevId,articol,
        soapData{
          id, report, receipt, datetime, card{
            name, address, idnx, factory, number, key
          },
          activities{
            field{
              name, amount, price,
              tax{code, percent,rate},
              cost,
              others{
                field{
                  type, percent, rate
                }
              }
            },
            taxes{field{code, percent,rate}}
          },
          data{
            total, subtotal, change, deposit, idns,
            payments{field{type, deposit}},
          }
        },
        author{id,simpalsLogin,simpalsId,organizationId,accesses{id,organizationId,role},name}
        cashier{
          id
        }
      }
      }`,
        },
    })
        .then(res => {
            return res.data;
        })
        .catch(err => {
            return err.message;
        });
    return organization;
}

// POST request to GraphQL  Get report by id
export function getReportById(id) {
    const organization = axios({
        url: basePath,
        method: 'post',
        data: {
            query: `
       query {
        getReport(id: ${id}){
        id,status, articol,
        soapData{
          id, report, type, datetime, card{
            name, address, idnx, factory, number
          },
          daily{
            taxes{
              field{
                code, percent, rate, cost
              }
            },
            untaxed, total, tax,
            receipts{
              field{
                type, count
              }
            },
            payments{
              field{type, total}
            },
            totals{in_,out,balance}
          },
          year{total, tax}
        }
      }
      }`,
        },
    })
        .then(res => {
            return res.data;
        })
        .catch(err => {
            return err.message;
        });
    return organization;
}

// POST request to GraphQL get all service receipts
export function getAllMyServiceReceipts(
    { dateFrom, dateTo },
    limit,
    start,
    cashRegisterId,
    cashier_id,
    cashier_name,
) {
    const receiptsVars = {
        sort: {
            column: '_id',
            direction: 'DESC',
        },
        ...(dateFrom && { dateFrom }),
        ...(dateTo && { dateTo }),
    };

    const { sort, dateFrom: fromDate, dateTo: toDate } = receiptsVars;

    const organization = axios({
        url: basePath,
        method: 'post',
        data: {
            query: `
       query{
        getServiceReceipts(
            sort: {
              column: "${sort.column}", 
              direction: ${sort.direction} 
            }
             ${fromDate ? `, dateFrom: "${fromDate}"` : ''}
             ${toDate ? `, dateTo: "${toDate}"` : ''}
             ${limit ? `, limit: ${limit}` : ''},
             ${cashRegisterId ? `, cashRegisterId: ${cashRegisterId}` : ''},
             ${cashier_id ? `, cashierId: ${cashier_id}` : ''},
             ${cashier_name ? `, cashierName: "${cashier_name}"` : ''},
             start: ${start},
            ){
          count,
          data{
            id,
            cashier {
              id,
              name,
            },
            soapData{
              id,report, datetime,
              data{total, type, name}
            },
            status,
          }
        }
      }`,
        },
    })
        .then(res => {
            return res.data;
        })
        .catch(err => {
            return err.message;
        });
    return organization;
}

// POST request to GraphQL  Get Service Receipt by id
export function getServiceReceiptById(id) {
    const organization = axios({
        url: basePath,
        method: 'post',
        data: {
            query: `
       query {
        getServiceReceipt(id: ${id}){
        id,status,
        soapData{
          id, report, datetime, card{
            name, address, idnx, factory, number
          },
          data{
            total, name, type
          }
        }
      }
      }`,
        },
    })
        .then(res => {
            return res.data;
        })
        .catch(err => {
            return err.message;
        });
    return organization;
}

// POST request to GraphQL get all users
export function getUsersList({ start, limit, id, simpalsLogin, name, role }) {
    // Create the base query for start and limit, which are always needed
    let query = `
      query {
          getUsers(start: ${start}, limit: ${limit}`;

    // Append fields conditionally based on whether the values are provided
    if (id) query += `, Id: ${id}`;
    if (simpalsLogin) query += `, simpalsLogin: "${simpalsLogin}"`;
    if (name) query += `, name: "${name}"`;
    if (role) query += `, role: ${role}`;

    // Close the query string
    query += `) {
      data {
        id, 
        simpalsLogin, 
        simpalsId, 
        organizationId,
        name,
        accesses {
          id, 
          role
        },
        cashRegisters {
          cashRegisterId
        }
      }
      count
    }
  }`;

    // Perform the request
    const users = axios({
        url: basePath,
        method: 'post',
        data: {
            query,
        },
    })
        .then(res => {
            return res.data;
        })
        .catch(err => {
            return err.message;
        });

    return users;
}

// POST request to GraphQL get all users
export function getUserById(id) {
    const users = axios({
        url: basePath,
        method: 'post',
        data: {
            query: `
          query {
            getUser(id: ${id}){
              id,
              simpalsLogin,
              simpalsId,
              organizationId,
              name,
              blocked,
              deleted,
              accesses {
                role
                id
              }
              cashRegisters {
                cashRegisterId
                apiKey
                cashRegister {
                  id
                  number
                }
              }
            }
          }
        `,
        },
    })
        .then(res => {
            return res.data;
        })
        .catch(err => {
            return err.message;
        });
    return users;
}

export function getEnumRoles() {
    const roles = axios({
        url: basePath,
        method: 'post',
        data: {
            query: `{   
      __type(name: "Role") {
        enumValues {
          name
          description
        }
      }
    }`,
        },
    })
        .then(res => {
            return res.data;
        })
        .catch(err => {
            return err.message;
        });
    return roles;
}

export function simpalsUserAutocomplete(userLogin) {
    const organization = axios({
        url: basePath,
        method: 'post',
        data: {
            query: `
      query{
        simpalsUserAutocomplete(filter: "${userLogin}"){
          userId,
          login
        }
      }`,
        },
    })
        .then(res => {
            return res.data;
        })
        .catch(err => {
            return err.message;
        });
    return organization;
}

// POST request to GraphQL get all companyes
export function getOrganizations(filter) {
    const organization = axios({
        url: basePath,
        method: 'post',
        data: {
            query: `
     query{
      getOrganizations(filter: ${filter}){
        data{
          id, 
          name, 
          idno, 
          contact, 
          contactPhone, 
          contactEmail, 
          cashRegistersCount,
          organizationPhone,
          organizationEmail,
        }
        count
      }
    }`,
        },
    })
        .then(res => {
            return res.data;
        })
        .catch(err => {
            return err.message;
        });
    return organization;
}

// POST request to GraphQL get all companyes
export function userAccessManage(userAccess) {
    const organization = axios({
        url: basePath,
        method: 'post',
        data: {
            query: `
          mutation{
            userAccessManage(create: ${userAccess.create}, role: ${userAccess.role}, userId: ${userAccess.userId}){
              errors {
                message
              }
              user {
                id,
                simpalsLogin,
                simpalsId,
                organizationId,
                name,
                blocked,
                deleted,
                accesses {
                  role
                  id
                }
                cashRegisters {
                  cashRegisterId
                  apiKey
                  cashRegister {
                    id
                    number
                  }
                }
              }
            }
        }`,
        },
    })
        .then(res => {
            return res.data;
        })
        .catch(err => {
            return err.message;
        });
    return organization;
}

// POST request to GraphQL create user
export function createUser(user) {
    const newUser = axios
        .post(basePath, {
            query: `
          mutation createUser($input: PublicUserCreateInput!) {
            userCreate(input: $input) {
              errors {
                message
              }
            }
          }
        `,
            variables: {
                input: {
                    name: user.name,
                    simpalsId: user.simpalsId,
                    accesses: user.accesses,
                },
            },
        })
        .then(res => {
            return res.data;
        })
        .catch(err => {
            return err.message;
        });
    return newUser;
}

// POST request to GraphQL update user
export function updateUser(user) {
    const updatedUsed = axios({
        url: basePath,
        method: 'post',
        data: {
            query: `
       mutation{
        userUpdate(
          input: {
            name: "${user.name}",
            id: ${user.id},
          },
        ){
          errors {message}
        }
      }`,
        },
    })
        .then(res => {
            return res.data;
        })
        .catch(err => {
            return err.message;
        });
    return updatedUsed;
}

// POST request to GraphQL update userApiKeyRefresh(
export function userKeyCashRegister(cashRegisterAccess) {
    const userApiKeyRefresh = axios({
        url: basePath,
        method: 'post',
        data: {
            query: `
          mutation{
            userApiKeyRefresh(
                create: ${cashRegisterAccess.create}
                cashRegisterId: ${cashRegisterAccess.cashRegisterId},
                userId: ${cashRegisterAccess.userId},
            ){
              errors {message}
              user {
                id,
                simpalsLogin,
                simpalsId,
                organizationId,
                name,
                blocked,
                deleted,
                accesses {
                  role
                  id
                }
                cashRegisters {
                  cashRegisterId
                  apiKey
                  cashRegister {
                    id
                    number
                  }
                }
              }
            }
          }`,
        },
    })
        .then(res => {
            return res.data;
        })
        .catch(err => {
            return err.message;
        });
    return userApiKeyRefresh;
}

// POST request to GraphQL upsert tax
export function upsertCashRegisterTax(cash_id, taxData) {
    const upsertCashRegisterTax = axios({
        url: basePath,
        method: 'post',
        data: {
            query: `
          mutation{
            upsertCashRegisterTax(
              cash_register_id: ${cash_id},
              tax: {
                id: ${taxData.id},
                title: "${taxData.title}",
                percent: ${taxData.percent},
                code: "${taxData.code}",
                rate: ${taxData.rate},
                enabled: ${taxData.enabled},
              }
            ){
              errors {
                message
              }
              data {
                id,
                title,
                percent,
                code,
                rate,
                enabled
              }
            }
        }`,
        },
    })
        .then(res => {
            return res.data;
        })
        .catch(err => {
            return err.message;
        });
    return upsertCashRegisterTax;
}

// POST request to GraphQL remove tax
export function removeCashRegisterTax(cash_id, tax_id) {
    const removeCashRegisterTax = axios({
        url: basePath,
        method: 'post',
        data: {
            query: `
          mutation{
            removeCashRegisterTax(
              cash_register_id: ${cash_id},
              tax_id: ${tax_id},
            ){
              errors {
                message
              }
              data {
                id,
                title,
                percent,
                code,
                rate,
                enabled
              }
            }
        }`,
        },
    })
        .then(res => {
            return res.data;
        })
        .catch(err => {
            return err.message;
        });
    return removeCashRegisterTax;
}
